import React from 'react';
import { Leaf, Battery, Zap, TreePine } from 'lucide-react';

const STATS = [
  { value: '38%',  label: 'EV fleet by Dec 2026', icon: Battery },
  { value: '2.4M', label: 'kg CO\u2082 saved this year', icon: Leaf },
  { value: '120+', label: 'Fast-charge stations partnered', icon: Zap },
  { value: '14',   label: 'Tree-plantation drives funded', icon: TreePine },
];

export default function Sustainability() {
  return (
    <section className="relative bg-white py-24 md:py-32 overflow-hidden">
      <div className="absolute -left-32 top-32 w-72 h-72 rounded-full bg-[#0E8A3F]/8 blur-3xl pointer-events-none" />
      <div className="max-w-[1280px] mx-auto px-5 md:px-8 grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
        <div className="relative">
          <div className="aspect-[4/5] rounded-[32px] overflow-hidden ring-1 ring-black/[0.06] relative bg-[#EAF8EE]">
            <img
              src="https://images.unsplash.com/photo-1593941707882-a5bba14938c7?w=1200&q=80&auto=format&fit=crop"
              alt="Electric vehicle charging"
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0E8A3F]/40 via-transparent to-transparent" />
          </div>
          {/* Floating green badge */}
          <div className="absolute -right-4 -bottom-4 md:-right-8 md:-bottom-8 bg-white rounded-2xl p-5 shadow-[0_30px_60px_-20px_rgba(15,15,16,0.18)] ring-1 ring-black/[0.04] flex items-center gap-3 max-w-[260px]">
            <div className="w-12 h-12 rounded-xl bg-[#EAF8EE] text-[#0E8A3F] grid place-items-center flex-shrink-0">
              <Leaf size={22} />
            </div>
            <div>
              <div className="text-[14px] font-semibold text-[#0f0f10]">Carbon-neutral by 2030</div>
              <div className="text-[12px] text-[#6b6b70] mt-0.5">Pledged. Audited yearly.</div>
            </div>
          </div>
        </div>

        <div>
          <span className="inline-flex items-center gap-2 text-[11px] font-semibold tracking-[0.18em] text-[#0E8A3F]">
            <Leaf size={13} /> CLEANER COMMUTES
          </span>
          <h2 className="mt-3 text-[34px] md:text-[48px] font-semibold tracking-[-0.02em] leading-[1.05] text-[#0f0f10]">
            Every ride a step toward <span className="text-[#0E8A3F]">cleaner air</span>.
          </h2>
          <p className="mt-5 text-[15px] md:text-[17px] text-[#3a3a3d] leading-relaxed max-w-lg">
            We are switching 40% of our fleet to electric by 2026, planting a tree for every 500th ride, and partnering with India’s fastest-growing charging networks — Tata Power EZ, Statiq, and Ather Grid.
          </p>

          <div className="mt-10 grid grid-cols-2 gap-4">
            {STATS.map((s) => {
              const I = s.icon;
              return (
                <div key={s.label} className="bg-[#f7f7f5] rounded-2xl p-5 ring-1 ring-black/[0.04]">
                  <I size={20} className="text-[#0E8A3F]" />
                  <div className="mt-3 text-[26px] md:text-[30px] font-semibold text-[#0f0f10] tracking-tight">{s.value}</div>
                  <div className="text-[12.5px] text-[#6b6b70] mt-1 leading-snug">{s.label}</div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
